var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chip',{attrs:{"label":"","color":_vm.color}},[_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.icon),expression:"icon"}],staticClass:"mr-1",attrs:{"small":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.label)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }